export default __webpack_public_path__ + "static/media/Readme-generator-screenshot.5971a153.png";